<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col :span="4">
          <el-select v-model="queryInfo.status" placeholder="请选择" @change="handleCurrentChange(1)">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="addDialogVisible = true">新增标签</el-button>
        </el-col>
      </el-row>

      <!-- 标签列表区域 -->
      <el-table :data="postlist" border stripe>
        <el-table-column label="编号" type="index"></el-table-column>
        <el-table-column label="标签名称" prop="PostName"></el-table-column>
        <el-table-column label="标签排序" prop="PostSort"></el-table-column>
        <el-table-column label="状态" prop="Status">
          <template slot-scope="scope">
            <span v-if="scope.row.Status == '0'">停用</span>
            <span v-if="scope.row.Status == '1'">正常</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="Remark"></el-table-column>
        <el-table-column label="创建时间" prop="UpdatedAt"></el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-tooltip effect="dark" content="修改" placement="top" :enterable="false">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)"></el-button>
            </el-tooltip>
            <!-- 删除按钮 -->
            <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="removePostById(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum" :page-sizes="[1,10, 20, 50]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 添加标签的对话框 -->
    <el-dialog title="添加标签" :visible.sync="addDialogVisible" width="30%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="标签名称" prop="postName">
          <el-input v-model="addForm.postName" placeholder="请输入标签名称"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="addForm.remark"  placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addPost">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改标签的对话框 -->
    <el-dialog title="修改标签" :visible.sync="editDialogVisible" width="30%" @close="editDialogClosed">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="90px">
        <el-form-item label="标签名称" prop="PostName">
          <el-input v-model="editForm.PostName"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input type="textarea" v-model="editForm.Remark" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editPostInfo">确 定</el-button>
      </span>
    </el-dialog>
   </div>
</template>

<script>
  import { chat_del, chat_get, chat_post, toForm } from '@/api'
  export default {
    data() {
      return {
        // 获取标签列表的参数对象
        queryInfo: {
          status: 1,
          pagenum: 1,
          pagesize: 10
        },
        postlist: [],
        total: 0,
        // 控制添加标签对话框的显示与隐藏
        addDialogVisible: false,
        // 添加标签的表单数据
        addForm: {
          postName: '',
          postCode: '0',
          postSort: 1,
          status: '1',
          remark: ''
        },
        // 添加表单的验证规则对象
        addFormRules: {
          postName: [
            { required: true, message: '请输入标签名称', trigger: 'blur' }
          ],
          postSort: [
            { required: true, message: '请输入标签顺序', trigger: 'blur' },
          ]
        },
        // 控制修改标签对话框的显示与隐藏
        editDialogVisible: false,
        // 查询到的标签信息对象
        editForm: {

        },
        // 修改表单的验证规则对象
        editFormRules: {
          PostName: [
            { required: true, message: '标签名称不能为空', trigger: 'blur' }
          ],
          PostSort: [
            { required: true, message: '标签顺序不能为空', trigger: 'blur' }
          ],
        }
      }
    },
    created() {
      this.getPostList()
    },
    methods: {
      getPostList() {
        chat_get(`/admin/v1/sysTag?size=${this.queryInfo.pagesize}&page=${this.queryInfo.pagenum}&status=${this.queryInfo.status}`, {}, res => {
          if(res.status == 200) {
            let { List: postList, Total } = res.data.MessageContent
            this.total = Total
            this.postlist = postList
          }
        })
      },
      // 监听 pagesize 改变的事件
      handleSizeChange(newSize) {
        this.queryInfo.pagesize = newSize
        this.getPostList()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange(newPage) {
        this.queryInfo.pagenum = newPage
        this.getPostList()
      },
      // 监听添加标签对话框的关闭事件
      addDialogClosed() {
        this.$refs.addFormRef.resetFields()
      },
      // 点击按钮，添加新标签
      addPost() {
        let params = toForm(this.addForm)
        this.$refs.addFormRef.validate(valid => {
          if (!valid) return
          chat_post('/admin/v1/sysTag', params, res => {
            if(res.status == 200) {
              this.$message.success('添加标签成功！')
              // 隐藏添加标签的对话框
              this.addDialogVisible = false
              // 重新获取标签列表数据
              this.getPostList()
            }
          })
        })
      },
      // 展示编辑标签的对话框
      showEditDialog(row) {
        this.editForm = {
          ...row
        }
        this.editDialogVisible = true
      },
      // 监听修改标签对话框的关闭事件
      editDialogClosed() {
        this.$refs.editFormRef.resetFields()
      },
      // 修改标签信息并提交
      editPostInfo() {
        this.$refs.editFormRef.validate(valid => {
          if (!valid) return
          console.log(this.editForm)
          let {PostCode,PostName, PostSort, Status, Remark, Id} = this.editForm
          let params = toForm({
            postCode: PostCode,
            postName: PostName,
            postSort: PostSort,
            status: Status,
            remark: Remark,
            id: Id
          })
          chat_post('/admin/v1/upTag', params, res => {
            if(res.status == 200) {
              // 关闭对话框
              this.editDialogVisible = false
              // 刷新数据列表
              this.getPostList()
              // 提示修改成功
              this.$message.success('更新标签信息成功！')
            }
          })
        })
      },
      // 根据Id删除对应的标签信息
      removePostById(oneUser) {
        let vm = this;
        this.$confirm( `此操作将删除"${oneUser.PostName}"标签, 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          chat_del(`/admin/v1/sysTag/${oneUser.Id}`, {}, res => {
            if(res.status == 200) {
              vm.getPostList()
              vm.$message({
                type: 'success',
                message: `删除成功!`
              });
            }
          })
        }).catch(() => {
          oneUser.Status = !oneUser.Status
        });
      },
    }
  }
</script>

<style lang="less" scoped>
</style>
